export default {
  dataPermission: null
}
